import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const ConfigurationModule = lazy(loadModule);

export default ConfigurationModule;
